// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1e0c11a7","667":"6012f172","977":"ca634eb4"}[chunkId] + ".chunk.js";
};